export default __webpack_public_path__ + "static/media/c-sharp.ab9c7be4.jpeg";